const CompactShort = new Intl.NumberFormat("en-US", {
  notation: "compact",
  compactDisplay: "short",
})

export const compactShort = (x: number): string => {
  return CompactShort.format(x)
}

const Percent = new Intl.NumberFormat("en-US", {
  style: "percent",
  signDisplay: "always",
})

export const percent = (x: number): string => {
  return Percent.format(x)
}

/*
  Currencies
*/
const currencyLongFmt = (currency?: string) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency || "MYR",
    currencyDisplay: "narrowSymbol",
  })

export const currencyLong =
  (currency?: string) =>
  (x: number): string => {
    return currencyLongFmt(currency).format(x)
  }

const SGDFormat = new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
})

export function customSGDFormat(x: number): string {
  const s = SGDFormat.format(x)
  return "S$ " + s
}
